module.exports = __webpack_public_path__ + "img/img2.1ef84693.jpg";